<template>
  <div id="result">
    <!-- <v-card
      class="mx-auto"
      max-width="400"
      color="#f6f6fa"
      min-height="100"
    >
      <p style="color:#FFFFFF;background-color:#5555BB"><b>結果表示</b></p>
      <div v-if="isHost">
        <p>ホストユーザはゲーム結果を<br>表示させることができます．</p>
        <v-btn class="send-button" large color="#229954" outlined min-width=80><b>ゲーム結果を表示</b></v-btn>
      </div>
      <div v-else>
        <p>ホストユーザはゲーム結果を<br>表示させることができます．</p>
        <v-btn class="send-button" large color="#229954" outlined min-width=80><b>ゲーム結果を表示</b></v-btn>
      </div>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="400"
      color="#f6f6fa"
      min-height="100"
    >
      <p style="color:#FFFFFF;background-color:#C71585"><b>次のゲームを始める</b></p>
      <div v-if="isHost">
        <p>ホストユーザは全員が揃ったらボタンを押して，<br>次のゲームを開始して下さい．</p>
        <v-btn v-on:click="assignRole" class="send-button white--text" large color="#229954" min-width=80><b>ゲームを始める</b></v-btn>
      </div>
      <div v-else>
        <p>ホストユーザは全員が揃ったらボタンを押して，<br>次のゲームを開始して下さい．</p>
        <v-btn class="send-button" large color="#229954" outlined min-width=80><b>ゲームを始める</b></v-btn>
      </div>
    </v-card> -->

    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      color="#f6f6fa"
      min-height="100"
    >
      <p style="color:#FFFFFF;background-color:#C71585"><b>ホーム画面に戻る</b></p>
        <p>ボタンを押すと，<br>ホーム画面に戻ります．</p>
        <div class="send-button">
          <sendButton v-on:pushed="returnHome" label="ホームに戻る" active="true"/>
        </div>
    </v-card>

  </div>
</template>
<script>
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "result",
  plops: [],
  components: {
    sendButton
  },
  data() {
    return {
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      isHost: this.$store.getters.isHost,
    };
  },
  computed: {

  },
  methods: {
    assignRole() {
      this.$emit("send-request", {"action": "assign-role", "roomId": this.roomId, "userId": this.userId, data: {}})
    },
    returnHome() {
      this.$store.commit('clearUserInfo')
      this.$store.commit('clearGameInfo')
      this.$store.commit('clearMissionInfo')
      this.$store.commit('clearUserList')
      window.close();
      // this.$router.push({ name: 'Home', params: {}})
    }
  },
  created (){
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      var loadedUsers = []
      if (res.data.state != "ready"){
        self.$store.commit("clearMissionInfo")
        loadedUsers = convertRoles(res.data.roles)
        for (var i in loadedUsers){
          var item = loadedUsers[i]
          if (item.userId == res.data.firstLeader){
            loadedUsers[i].isLeader = true
          }
          if (self.userId == item.userId){
            self.$store.commit('setMyRole', item.role)
          }
        }
        self.$store.commit('setUsers', loadedUsers)
        self.$store.commit('setMissionRequirement', loadedUsers.length)

        if (self.userId == res.data.firstLeader){
          self.$store.commit('beLeader')
        }else {
          self.$store.commit('beMember')
        }

        self.$emit("show-text", {state: "ready", text: "役割が決定されました．"})

        var nextState = "checking-role"
        if (res.state == "checking-role"){
          nextState = "checkingRole"
        }
        self.$emit("proceed-state", nextState)
      }else {
        const userName = res.data.userName
        const stateKey = res.state + "-" + userName
        self.$emit("show-text", {state: stateKey, text: (userName + "が入室しました．")})
        loadedUsers = res.data.userList

        self.$store.commit('setUsers', loadedUsers)
      }
    }
  }
}
function convertRoles(roles) {
  var userList = []
  for( var i in roles ){
    var item = roles[i]
    console.log(item)
    userList.push({userName: item.userName, userId: item.userId, role: item.role, isLeader: false})
  }
  return userList
}
</script>
<style>
#result .send-button {
  padding-bottom: 12px
}
</style>
